import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function UsersAdmin() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [form,    setForm]    = useState({ username: '', email: '', password: '', role: 'user' });
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState('');
  const [creating, setCreating] = useState(false);

  const load = () => {
    setLoading(true);
    axios.get('/api/users').then(r => setUsers(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleCreate = async e => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!form.username || !form.email || !form.password) { setError('All fields required'); return; }
    setCreating(true);
    try {
      await axios.post('/api/users', form);
      setSuccess(`User "${form.username}" created successfully`);
      setForm({ username: '', email: '', password: '', role: 'user' });
      load();
    } catch (err) {
      setError(err.response?.data?.message || 'Error creating user');
    } finally { setCreating(false); }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete user "${name}"?`)) return;
    try {
      await axios.delete(`/api/users/${id}`);
      load();
    } catch (err) {
      alert(err.response?.data?.message || 'Error');
    }
  };

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: 14, fontWeight: 700, letterSpacing: '.05em', marginBottom: 20 }}>
        User Management
      </h2>

      {/* Create form */}
      <div className="card" style={{ marginBottom: 24 }}>
        <h3 style={{ fontFamily: 'Syne, sans-serif', fontSize: 12, fontWeight: 700, letterSpacing: '.06em', marginBottom: 14, color: 'var(--accent2)' }}>
          CREATE NEW USER
        </h3>
        <form onSubmit={handleCreate} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 120px auto', gap: 10, alignItems: 'end' }}>
          <div>
            <label style={{ fontSize: 9, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '.06em' }}>USERNAME</label>
            <input className="input" placeholder="johndoe" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
          </div>
          <div>
            <label style={{ fontSize: 9, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '.06em' }}>EMAIL</label>
            <input className="input" type="email" placeholder="john@example.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label style={{ fontSize: 9, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '.06em' }}>PASSWORD</label>
            <input className="input" type="password" placeholder="••••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </div>
          <div>
            <label style={{ fontSize: 9, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '.06em' }}>ROLE</label>
            <select className="input" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}
              style={{ cursor: 'pointer' }}>
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <button className="btn btn-primary" type="submit" disabled={creating} style={{ whiteSpace: 'nowrap' }}>
            {creating ? '…' : '+ Create'}
          </button>
        </form>
        {error   && <div className="error-msg"   style={{ marginTop: 10 }}>{error}</div>}
        {success && <div className="success-msg" style={{ marginTop: 10 }}>{success}</div>}
      </div>

      {/* User list */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontFamily: 'Syne, sans-serif', fontSize: 12, fontWeight: 700 }}>ALL USERS</span>
          <span className="tag">{users.length}</span>
        </div>
        {loading ? (
          <div style={{ padding: 20, color: 'var(--muted)', fontSize: 12 }}>Loading…</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: 'var(--row-overlay)' }}>
                {['Username','Email','Role','Created',''].map(h => (
                  <th key={h} style={{ padding: '8px 16px', textAlign: 'left', fontSize: 9, color: 'var(--muted)', letterSpacing: '.06em', fontWeight: 700, borderBottom: '1px solid var(--border)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u._id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '10px 16px', fontWeight: 600 }}>{u.username}</td>
                  <td style={{ padding: '10px 16px', color: 'var(--muted)' }}>{u.email}</td>
                  <td style={{ padding: '10px 16px' }}><span className={`tag tag-${u.role}`}>{u.role}</span></td>
                  <td style={{ padding: '10px 16px', color: 'var(--muted)', fontSize: 10 }}>{new Date(u.createdAt).toLocaleDateString()}</td>
                  <td style={{ padding: '10px 16px' }}>
                    {u.role !== 'admin' && (
                      <button className="btn btn-danger" onClick={() => handleDelete(u._id, u.username)} style={{ fontSize: 10, padding: '4px 10px' }}>
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
